import { ScheduleEntry } from "./ScheduleEntry.model";


export class Schedule {
  id: number;
  name: string;
  description: string;
  entries: ScheduleEntry[];

  constructor() {
    this.id = -1;
    this.name = "";
    this.description = "";
    this.entries = []
  }
}
